import { ALL_MODELS, findModelById, type Model } from '../types/model.types';

export function resolveModelById(
  modelId: string,
  catalogModels?: Model[]
): Model | undefined {
  if (catalogModels?.length) {
    const fromCatalog = catalogModels.find(m => m.id === modelId);
    if (fromCatalog) return fromCatalog;
  }
  return findModelById(modelId);
}

export function findModelMatching(
  predicate: (m: Model) => boolean,
  catalogModels?: Model[]
): Model | undefined {
  if (catalogModels?.length) {
    const fromCatalog = catalogModels.find(predicate);
    if (fromCatalog) return fromCatalog;
  }
  return ALL_MODELS.find(predicate);
}
